import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreatePollRequestBody,
  IApiCreatePollResponseBody,
} from '../PollsApi.types';
import { useApi } from '~/lib/api/useApi';
import { pollQueryKeyFactory } from './usePollQuery';
import { pollsQueryKeyFactory } from './usePollsQuery';

export type IUseCreatePollMutationValues = {
  appId: string;
  body: IApiCreatePollRequestBody;
};

export const useCreatePollMutation = (): UseMutationResult<
  IApiCreatePollResponseBody,
  unknown,
  IUseCreatePollMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreatePollMutationValues) =>
      api.polls.create(values.appId, values.body),
    onSuccess: async (createdPoll, values) => {
      queryClient.setQueryData(
        pollQueryKeyFactory({
          ...values,
          pollId: createdPoll._id,
        })!,
        createdPoll,
      );
      await queryClient.invalidateQueries({
        queryKey: pollsQueryKeyFactory(),
      });
    },
  });
};
